import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconFilterListLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.029 17.5a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535a.725.725 0 0 1 .534-.215h1.932c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534.725.725 0 0 1-.215.535.726.726 0 0 1-.535.215H11.03Zm-3.875-4.75a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h9.683c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216H7.154ZM4.25 8a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.725.725 0 0 1 4.25 6.5h15.5c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H4.25Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFilterListLine;
